import { render, staticRenderFns } from "./AddonPayQr.vue?vue&type=template&id=f56a4142&scoped=true"
import script from "./AddonPayQr.vue?vue&type=script&lang=js"
export * from "./AddonPayQr.vue?vue&type=script&lang=js"
import style0 from "./AddonPayQr.vue?vue&type=style&index=0&id=f56a4142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56a4142",
  null
  
)

export default component.exports